import { Modal } from "react-bootstrap";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { SendFile } from "Services/PGXLis/ResultUpload";
import useLang from "Shared/hooks/useLanguage";

function ResendModal({
  id,
  show,
  setShow,
  templateId,
  loadGridData,
}: {
  id: number;
  setShow: any;
  show: boolean;
  templateId: number;
  loadGridData: (loader: boolean, reset: boolean, sortingState?: any) => void;
}) {
  const { t } = useLang();

  const ModalhandleClose = () => setShow(false);

  const resendMutation = useMutation({
    mutationFn: async ({
      tempId,
      fileId,
    }: {
      tempId: number;
      fileId: number;
    }) => {
      const res = await SendFile(tempId, fileId);
      return res.data;
    },
    onSuccess: (data) => {
      if (data.statusCode === 200) {
        toast.success(data.message);
        loadGridData(true, true);
      }
    },
    onError: (error: any) => {
      console.error(error);
      toast.error("Resend failed");
    },
  });

  return (
    <Modal
      show={show}
      onHide={ModalhandleClose}
      backdrop="static"
      keyboard={false}
      className="d-flex align-item-center"
      dialogClassName="no-shadow-modal-content"
    >
      <Modal.Header closeButton className="py-4 bg-light-primary">
        <Modal.Title className="h5">{t("Resend Record")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {t("Are you sure you want to resend this record ?")}
      </Modal.Body>
      <Modal.Footer className="py-2">
        <button
          id="PGXResultFileModalResendCancel"
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={ModalhandleClose}
        >
          {t("Cancel")}
        </button>
        <button
          id="PGXResultFileModalResendSave"
          type="button"
          className="btn btn-sm btn-danger"
          onClick={() =>
            resendMutation.mutate({
              tempId: templateId,
              fileId: id,
            })
          }
        >
          {t("Resend")}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ResendModal;
